const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/faq/validators/action-validators.js